import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../../../services/product.service';
import * as _ from 'lodash';
import { EfulfillmentService } from '../../../services/efulfillment.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';

@Component({
  selector: 'app-e-fulfillment-form',
  template: require('./e-fulfillment-form.component.html'),
  styles: [require('./e-fulfillment-form.component.css')]
})
export class EFulfillmentFormComponent implements OnInit {

    applicantForm: FormGroup = new FormGroup({})
    currentEFulfillment = {} as any;
    fileUpload: File;
    isCreate: boolean = false;
    isDelete: boolean = false;
    isLoading: boolean = false;
    cardTemplateList: any[];
    fileImage;
    externalFile: boolean = false;
    isPdf: boolean = true;
    isClearingCache: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EFulfillmentFormComponent>, private fb: FormBuilder,
        private eFulfilmentService: EfulfillmentService,
        private alertService: AlertService
    ) {
        //console.log(data)
        if (data) {
            this.getEfulfillmentDetail(this.data.plan.productId)
            //this.getCardTemplateFormAzure()
        }
    }

    ngOnInit() {
        this.applicantForm = this.fb.group({
            enabled: [''],
            emailTemplateId: [''],
            cardTemplate: [''],
            welnessCard: [''],
            welnessCardStandard : [''],
        })
    }

    getEfulfillmentDetail(productId) {
        this.isLoading = true
        this.eFulfilmentService.getEFulfillmentDetail(productId).subscribe(r => {
            this.getCardTemplateFormAzure();
            if (r) {
                this.currentEFulfillment = r;
                //console.log(r)
            } else {
                this.currentEFulfillment.productId = productId
                this.isCreate = true
            }
            this.isLoading = false;
        })
    }

    close(isSave = false) {
        this.dialogRef.close({
            isSave: isSave
        })
    }

    save() {

        if (this.applicantForm.invalid) {
            Object.keys(this.applicantForm.controls).forEach(i => {
                this.applicantForm.controls[i].markAsTouched()
            })
            return;
        }
        this.isLoading = true;
        
        //console.log(this.currentEFulfillment)

        if (this.externalFile) { // have card template upload
            this.eFulfilmentService.uploadFilesToAzure(this.fileUpload).subscribe(r => {
                //console.log(r.pdfCardTemplateLink);
                
                if (!!r.pdfCardTemplateLink || r.pdfCardTemplateLink.length !== 0) { // not empty, null, undefined
                    this.currentEFulfillment.cardTemplatePath = r.pdfCardTemplateLink
                    this.eFulfilmentService.createEditEFulfillment(this.currentEFulfillment).subscribe(r => {
                        //console.log(r)
                        if (r) {
                            this.close(true)
                        }
                    })
                }
            })
        } else {
            this.eFulfilmentService.createEditEFulfillment(this.currentEFulfillment).subscribe(r => {
                //console.log(r)
                if (r) {
                    this.close(true)
                }
            })
        }
        

        
       

    }

    onSelectImage(e) {
        if (e.target.files && e.target.files[0]) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(e.target.files[0]);
            fileReader.onload = (event) => {
                this.currentEFulfillment.wellnessCardBackground = event.target.result;
                this.fileImage = e.target.files[0]
                this.currentEFulfillment.isUseStandard = false;
            }
        }
    }
    checkUseStandard(e) {
        this.currentEFulfillment.isUseStandard = e.checked;
        if (this.currentEFulfillment.isUseStandard) {
            this.currentEFulfillment.isUseStandard = true;
            this.currentEFulfillment.wellnessCardBackground = "";
        }
    }

    deleteFileUpload() {
        this.fileUpload = null
        this.externalFile = false;
    }

    onSelectFile(e) {
        if (e.target.files && e.target.files[0]) {
            if (e.target.files[0].type.includes('pdf')) {
                this.fileUpload = e.target.files[0];
                this.externalFile = true;
                this.isPdf = true;
            } else {
                this.isPdf = false;
            }


        }
    }

    getCardTemplateFormAzure() {
        this.eFulfilmentService.getCardTemplateAzure().subscribe(r => {
            this.cardTemplateList = r.map(i => {
                return {
                    name: _.last(i.name.split("/")),
                    cardTemplatePath: i.cardTemplatePath
                }
            });

            //console.log(this.cardTemplateList)

        })
    }

    clearTemplateCache() {
        this.isClearingCache = true;
        this.eFulfilmentService.clearTemplateCache().subscribe(r => {
            this.isClearingCache = false;
            if (r && r.success) {
                this.alertService.showMessage("Template cache cleared", `${r.cleared} cached template(s) dropped. The next welcome letter PDF will use the latest SendGrid template.`, MessageSeverity.success);
            } else {
                this.alertService.showMessage("Clear cache failed", "The template cache could not be cleared.", MessageSeverity.error);
            }
        }, err => {
            this.isClearingCache = false;
            this.alertService.showMessage("Clear cache failed", "The template cache could not be cleared.", MessageSeverity.error);
        });
    }

    changeCheckbox(e) {
        console.log(e.checked)
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/products/e-fulfillment-form/e-fulfillment-form.component.ts